import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    if (screen) {
      this.element.value = `${screen.width}x${screen.height}`
    }
  }
}
